<template>
  <!-- Table Container Card -->
  <b-card
    no-body
  >

    <div class="m-2">

      <!-- Table Top -->
      <b-row>

        <!-- Per Page -->
        <b-col
          cols="12"
          md="6"
          class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <TableEntries
            v-model="perPage"
            :options="perPageOptions"
          />
          <Button
            v-if="getUserPermission('CREATE_BUSINESS_AUTOMATION')"
            :label="$t('Add')"
            size="md"
            @click="showModal('modal-lg')"
          />
        </b-col>

        <!-- Search -->
        <b-col
          cols="12"
          md="6"
        >
          <div class="d-flex align-items-center justify-content-lg-end">
            <Button
              :label="$t('Filter')"
              size="md"
              icon="FilterIcon"
              show-icon
              class="mr-1"
              @click="showModal('modal-filter')"
            />
            <Button
              :label="$t('Reset Filter')"
              size="md"
              icon="RotateCwIcon"
              show-icon
              @click="resetFilter"
            />
          </div>
        </b-col>
      </b-row>

    </div>

    <b-table
      ref="nterBranchAccountAccountRef"
      :busy="isBusy"
      :items="unclearedChequeAccountList"
      responsive
      :fields="translatedTableHeaders"
      primary-key="id"
      show-empty
      :empty-text="$t('No records available')"
      class="position-relative"
    >

      <template #table-busy>
        <div class="text-center text-danger my-2">
          <b-spinner
            class="align-middle"
            variant="primary"
          />
        </div>
      </template>
      <template #cell(SN)="data">
        {{ getOverallIndex(data.index) }}
      </template>

      <!-- Column: Actions -->
      <template #cell(actions)="data">

        <div class="text-nowrap">
          <!-- Dropdown -->
          <b-dropdown
            variant="link"
            toggle-class="p-0"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >
            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>
            <b-dropdown-item
              v-if="getUserPermission('MODIFY_BUSINESS_AUTOMATION')"
              @click="onSelectChequeReceivableAccount(data.item, $event.target, 'edit')"
            >
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50"> {{ $t('Modify') }} </span>
            </b-dropdown-item>

            <b-dropdown-item @click="onSelectChequeReceivableAccount(data.item, $event.target, 'view')">
              <feather-icon icon="EyeIcon" />
              <span class="align-middle ml-50"> {{ $t('View') }} </span>
            </b-dropdown-item>
            <b-dropdown-item @click="onDeleteUnclearedChequeAccount(data.item, $event.target)">
              <feather-icon icon="TrashIcon" />
              <span class="align-middle ml-50"> {{ $t('Delete') }} </span>
            </b-dropdown-item>
          </b-dropdown>
        </div>
      </template>

    </b-table>

    <!-- Pagination -->
    <TablePagination
      v-model="currentPage"
      :from="from"
      :to="to"
      :total-rows="totalEntries"
      :per-page="perPage"
    />

    <!-- modal -->
    <b-modal
      id="modal-lg"
      ref="my-modal"
      no-close-on-backdrop
      :ok-title="buttonLabel"
      :cancel-title="$t('Cancel')"
      cancel-variant="outline-secondary"
      centered
      :ok-disabled="isLoading"
      size="md"
      :title="modalTitle"
      @hidden="resetModal"
      @ok="handleSubmit"
    >
      <validation-observer ref="unclearedChequeAccountRules">
        <b-form @submit.prevent="handleSubmit">
          <b-row class="match-height">
            <!-- Clearing Bank Name -->
            <b-col md="12">
              <SelectField
                id="clearing-bank-name"
                v-model="unclearedChequeAccountFormData.clearingBankCode"
                :label="$t('Clearing Bank Name')"
                :options="bankOptions"
                :reduce="option => option.value"
                :error-name="$t('Claearing Bank Name')"
                rules="required"
                item="label"
                placeholder="Select"
                :readonly="isReadonly"
              />
            </b-col>
            <!-- Claearing Bank Name -->

            <!-- Uncleared Cheque Account Number -->
            <b-col md="12">
              <SelectField
                id="mirrow-account"
                v-model="unclearedChequeAccountFormData.accountNumber"
                :label="$t('Uncleared Cheque Account Number')"
                :options="unclearedChequeAccountNumberOptions"
                :reduce="option => option.value"
                :error-name="$t('Uncleared Cheque Account Number')"
                rules="required"
                item="label"
                :placeholder="$t('Select')"
                :readonly="isReadonly"
              />
            </b-col>
            <!-- Uncleared Cheque Account Number -->
          </b-row>

        </b-form>
      </validation-observer>
      <template
        v-if="isReadonly"
        #modal-footer="{ }"
      >
        <div />
      </template>
    </b-modal>
    <!-- modal -->

    <!-- Filter modal -->
    <b-modal
      id="modal-filter"
      ref="my-modal"
      :ok-title="$t('Apply')"
      no-close-on-backdrop
      :cancel-title="$t('Cancel')"
      cancel-variant="outline-secondary"
      centered
      size="md"
      :title="$t('Filters')"
      modal-footer
      @ok="unclearedChequeAccount"
      @cancel="resetFilters"
    >
      <b-row class="match-height">
        <!-- Claearing Bank Name -->
        <b-col md="12">
          <SelectField
            id="clearing-bank-name"
            v-model="filter.clearingBankCode"
            :label="$t('Clearing Bank Name')"
            :options="bankOptions"
            :reduce="option => option.value"
            item="label"
            :placeholder="$t('Select')"
            :readonly="isReadonly"
          />
        </b-col>
        <!-- Claearing Bank Name -->

        <!-- Uncleared Cheque Account Number -->
        <b-col md="12">
          <SelectField
            id="mirrow-account"
            v-model="filter.accountNumber"
            :label="$t('Uncleared Cheque Account Number')"
            :options="unclearedChequeAccountNumberOptions"
            :reduce="option => option.value"
            item="label"
            :placeholder="$t('Select')"
            :readonly="isReadonly"
          />
        </b-col>
        <!-- Uncleared Cheque Account Number -->
      </b-row>
    </b-modal>
    <!-- Filter modal -->

    <FullScreenSpinner :show="showSpinner" />
  </b-card>

</template>

<script>
import {
  BCard, BRow, BCol, BTable, BModal, BSpinner,
  BForm, BDropdown, BDropdownItem,
} from 'bootstrap-vue'
import { ValidationObserver } from 'vee-validate'
import { mapActions, mapGetters } from 'vuex'
import { required } from '@validations'
import { modalMixins } from '@core/mixins/modal'
import { tableMixins } from '@core/mixins/table'
import { sweetAlert } from '@core/mixins/sweetAlert'
import { permissionMixin } from '@core/mixins/permission'
import { toAmount } from '@/helpers/formatAmount'
import TablePagination from '@/views/components/table/TablePagination.vue'
import TableEntries from '@/views/components/table/TableEntries.vue'
import FullScreenSpinner from '@/views/components/spinner/FullScreenSpinner.vue'
import SelectField from '../../../forms/SelectField.vue'
import Button from '../../../components/button/Button.vue'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    TablePagination,
    TableEntries,
    Button,
    BTable,
    BSpinner,
    BModal,
    BForm,
    BDropdown,
    BDropdownItem,
    ValidationObserver,
    SelectField,
    FullScreenSpinner,
  },
  mixins: [modalMixins, tableMixins, sweetAlert, permissionMixin],
  data() {
    return {
      isBusy: true,
      buttonLabel: this.$t('Save'),
      modalTitle: this.$t('Create Uncleared Cheque Account'),
      isReadonly: false,
      required,
      isRequired: false,
      isLoadingBanks: false,
      isLoading: false,
      showSpinner: false,
      sortDesc: false,
      toAmount,
      tableHeaders: [
        { key: 'SN', label: 'S/N' },
        { key: 'accountName', sortable: true, label: 'Account Name' },
        { key: 'accountNumber', sortable: true, label: 'Account Number' },
        { key: 'clearingBankName', sortable: true, label: 'Clearing Bank Name' },
        { key: 'actions', label: 'Actions' },
      ],
      unclearedChequeAccountFormData: {
        clearingBankCode: '',
        accountNumber: '',
      },
      unclearedChequeAccountList: [],
      unclearedChequeAccountNumberOptions: [],
      filter: {
        clearingBankCode: '',
        ClearingMirrowAccount: '',
      },
    }
  },
  computed: {
    ...mapGetters({
      bankOptions: 'operations/bankOptions',
    }),
    translatedTableHeaders() {
      return this.tableHeaders.map(header => ({ ...header, label: header.label ? this.$t(header.label) : header.key }))
    },
  },
  mounted() {
    this.getAccounts()
    this.unclearedChequeAccount()
  },
  methods: {
    ...mapActions({
      getUnclearedChequeAccount: 'operations/getUnclearedChequeAccountList',
      createUnclearedChequeAccount: 'operations/createUnclearedChequeAccountAction',
      updateUnclearedChequeAccount: 'operations/updateUnclearedChequeAccountAction',
      deleteBusinessAutomation: 'operations/deleteBusinessAutomation',
      getAccountCategoryByCode: 'account/getAccountCategoryByCode',
      getBanks: 'operations/getBanks',
    }),

    onSelectChequeReceivableAccount(items, activity, val) {
      this.isReadonly = val === 'edit' ? this.isReadonly = false : this.isReadonly = true
      this.modalTitle = val === 'edit' ? this.$t('Edit Uncleared Cheque Account') : this.$t('Uncleared Cheque Account')
      // const accountNumber = this.unclearedChequeAccountNumberOptions.find(item => item.value === items.accountNumber).label
      this.unclearedChequeAccountFormData = { ...items }
      this.buttonLabel = this.$t('Update')
      this.$root.$emit('bv::show::modal', 'modal-lg')
    },

    async unclearedChequeAccountAction() {
      try {
        this.isLoading = true
        const response = this.buttonLabel === 'Save'
          ? await this.createUnclearedChequeAccount(this.unclearedChequeAccountFormData)
          : await this.updateUnclearedChequeAccount(this.unclearedChequeAccountFormData)
        const { status } = response
        if (status === 200) {
          this.unclearedChequeAccount()
          this.hideModal('modal-lg')
          this.alertSuccess({ text: this.$t('Uncleared Cheque Account created successfully') })
        }
      } catch (error) {
        this.handleError(error)
      } finally {
        this.isLoading = false
      }
    },
    handleSubmit(bvModalEvt) {
      bvModalEvt.preventDefault()
      this.$refs.unclearedChequeAccountRules.validate().then(success => {
        if (success) {
          const areYouSUre = this.$t('Are you sure you want to')
          const unclearedText = this.$t('this Uncleared Cheque Account?')
          this.confirm(this.unclearedChequeAccountAction, { text: `${areYouSUre} ${this.buttonLabel} ${unclearedText}` })
        }
      })
    },

    async unclearedChequeAccount() {
      try {
        this.isBusy = true
        const response = await this.getUnclearedChequeAccount({
          search: this.filter,
          page: this.currentPage,
          limit: this.perPage,
        })
        const { data, status } = response
        if (status === 200 && data.data) {
          this.isBusy = false
          this.unclearedChequeAccountList = data.data
          this.totalCount = data.recordCount
        } else {
          this.unclearedChequeAccountList = []
        }
      } catch (error) {
        this.alertError({ text: error })
      } finally {
        this.isBusy = false
      }
    },
    // async fetchBanks() {
    //   try {
    //     this.isLoadingBanks = true
    //     const response = await this.getBanks()
    //     const { data, status } = response
    //     if (status === 200 && data.data) {
    //       // eslint-disable-next-line no-nested-ternary
    //       this.bankOptions = data.data.map(item => ({ label: item.name, value: item.code })).sort((a, b) => (a.label === b.label ? 0 : a.label < b.label ? -1 : 1))
    //     } else {
    //       this.bankOptions = []
    //     }
    //   } catch (error) {
    //     this.alertError({ text: error })
    //   } finally {
    //     this.isLoadingBanks = false
    //   }
    // },
    async getAccounts() {
      try {
        const response = await this.getAccountCategoryByCode(20421000)
        const { data, status } = response
        if (status === 200 && data.data) {
          this.unclearedChequeAccountNumberOptions = data.data.filter(item => item.status === 'Active').map(item => ({
            label: item.name,
            value: item.code.toString(),
          }))
        }
      } catch (error) {
        this.alertError({ text: error })
      }
    },
    async onDeleteUnclearedChequeAccount(item) {
      const deleteUnclearedChequeAccount = async () => {
        try {
          this.showSpinner = true
          const response = await this.deleteBusinessAutomation({ routeName: 'UnclearedChequeAccount', id: item.id })
          const { status } = response
          if (status === 200) {
            this.alertSuccess({ text: this.$t('Deleted successfully') })
            this.unclearedChequeAccount()
          }
        } catch (error) {
          this.alertError({ text: error })
        } finally {
          this.showSpinner = false
        }
      }
      this.confirm(deleteUnclearedChequeAccount, { text: this.$t('Are you sure you want to delete this Uncleared Cheque Account?') })
    },
    resetModal() {
      this.unclearedChequeAccountFormData = { ...null }
      this.isLoading = false
    },
    resetFilters() {
      this.filter = { ...null }
    },
    resetFilter() {
      this.filter = { ...null }
      this.unclearedChequeAccount()
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
